module.exports = __webpack_public_path__ + "f8575eaae8c7b8d8d81539abea97c819.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/checkbox.svg
// module id = 269
// module chunks = 0